import { ApplicationController, useDebounce } from 'stimulus-use';
import buildShouldExcludeKey from '../utils/build_should_exclude_key';

export default class AutosaveController extends ApplicationController {
  static values = {
    /**
     * autosave に使用する URL。
     * この URL に対してフォームの内容が POST される。
     */
    url: String,

    /**
     * autosave から除外する key のリスト。
     * / で始まり / で終わる文字列を指定すると、その中身が正規表現と解釈される。
     * この正規表現には ^ と $ が付与され、 key 全体にマッチするか評価される。
     * @example ["/example\\[.+/", "foo[bar][buzz]"]
     */
    except: { type: Array, default: [] }
  };

  static debounces = [
    'save'
  ];

  connect() {
    useDebounce(this, { wait: 5_000 });
  }

  async save() {
    const body             = new FormData(this.element);
    const shouldExcludeKey = buildShouldExcludeKey(this.exceptValue);
    const excludedKeys     = Array.from(body.keys()).filter(shouldExcludeKey);

    for (const k of excludedKeys) {
      body.delete(k);
    }

    body.set('authenticity_token', document.querySelector('meta[name="csrf-token"]').content);

    await fetch(this.urlValue, {
      method: 'POST',
      body
    });
  }
}
